import { types } from "../types/types";

const initialState = {

  roleFlowSaved: {},
  roleFlows: [],
  roleFlowCurrent: null,
  timeline: [],
  loading: false
};
export const roleFlowReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ROLEFLOW_START_REGISTER:
      return {
        ...state,
        roleFlowSaved: action.payload,
      };

    case types.ROLEFLOW_START_LOADING: {
      const roleFlowsArray = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.roleFlows || [];

      const firstRoleFlow = roleFlowsArray.length
        ? roleFlowsArray[0]
        : action.payload?.roleFlow || null;

      return {
        ...state,
        roleFlows: roleFlowsArray,
        roleFlowCurrent: firstRoleFlow,
        timeline: firstRoleFlow?.RoleFlow_To_FlowHistory || [],
        loading: false
      };
    }

    case types.ROLEFLOW_SET_TIMELINE:
      return {
        ...state,
        timeline: Array.isArray(action.payload) ? action.payload : []
      };

    case types.ROLEFLOW_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
};
